import { render, staticRenderFns } from "./DialogPageAboutChat.vue?vue&type=template&id=47533418"
import script from "./DialogPageAboutChat.vue?vue&type=script&lang=js"
export * from "./DialogPageAboutChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports